import { ValueOf } from '../utilities/types';
import languages, { Languages } from './languages';

const employmentStatuses = {
  FULL_TIME: 'fullTime',
  PART_TIME: 'partTime',
  SELF_EMPLOYED: 'self-employed',
  VARIABLE_HOURS_EMPLOYED: 'variable-hours-employed',
  STUDENT: 'student',
  UNEMPLOYED: 'unemployed',
  RETIRED: 'retired',
} as const;

const employmentStatusEnLabels = {
  [employmentStatuses.FULL_TIME]: 'Full-time employed',
  [employmentStatuses.PART_TIME]: 'Part-time employed',
  [employmentStatuses.SELF_EMPLOYED]: 'Self-employed',
  [employmentStatuses.VARIABLE_HOURS_EMPLOYED]: 'Variable-hours employed',
  [employmentStatuses.STUDENT]: 'Student',
  [employmentStatuses.UNEMPLOYED]: 'Unemployed/job seeking',
  [employmentStatuses.RETIRED]: 'Retired',
} as const;

const employmentStatusSvLabels = {
  [employmentStatuses.FULL_TIME]: 'Fast anställd',
  [employmentStatuses.PART_TIME]: 'Deltidsanställd',
  [employmentStatuses.SELF_EMPLOYED]: 'Egen företagare',
  [employmentStatuses.VARIABLE_HOURS_EMPLOYED]: 'Variabel anställningstid',
  [employmentStatuses.STUDENT]: 'Studerande',
  [employmentStatuses.UNEMPLOYED]: 'Arbetslös/arbetssökande',
  [employmentStatuses.RETIRED]: 'Pensionär',
} as const;

const employmentStatusDeLabels = {
  [employmentStatuses.FULL_TIME]: 'Vollzeit beschäftigt',
  [employmentStatuses.PART_TIME]: 'Teilzeit beschäftigt',
  [employmentStatuses.SELF_EMPLOYED]: 'Selbstständig',
  [employmentStatuses.VARIABLE_HOURS_EMPLOYED]: 'Beschäftigt mit flexiblen Arbeitszeiten',
  [employmentStatuses.STUDENT]: 'Studierend',
  [employmentStatuses.UNEMPLOYED]: 'Arbeitslos / arbeitssuchend',
  [employmentStatuses.RETIRED]: 'Im Ruhestand',
} as const;

const employmentStatusLabels = {
  [languages.EN]: employmentStatusEnLabels,
  [languages.SV]: employmentStatusSvLabels,
  [languages.DE]: employmentStatusDeLabels,
} as const;

export const employmentStatusChoices = (
  language: Languages,
) => Object.values(employmentStatuses).map((section) => ({
  id: section,
  name: employmentStatusLabels[language][section],
}));

export type EmploymentStatuses = ValueOf<typeof employmentStatuses>;

export default employmentStatuses;
